import { Card, Grid, SxProps, Theme, Typography } from '@mui/material';
import { formatPhoneNumber } from '../../lib/helper/format-phone-number';
import { SupportInformation } from '../../lib/models/SupportModels';
import EmailLink from './EmailLink';

const SupportCard = (props: SupportInformation) => {
    const { type, availability, supportContact } = props;

    if (supportContact.length === 0) {
        return (
            <Card sx={supportCardStyle}>
                <Typography variant={'h2'}>{type} Support</Typography>
                <Typography variant={'h6'} sx={{ color: 'cardSubtitle.main' }}>
                    {availability}
                </Typography>
                <Typography variant={'h6'} sx={{ color: 'cardSubtitle.main' }}>
                    No Support Contact data yet
                </Typography>
            </Card>
        );
    } else {
        return (
            <Card sx={supportCardStyle}>
                <Typography variant={'h2'}>{type} Support</Typography>
                <Typography variant={'h6'} sx={{ color: 'cardSubtitle.main' }}>
                    {availability}
                </Typography>

                <Grid container sx={mainGridStyle}>
                    {supportContact.map((element, index) => (
                        <Grid item sm={6} md={4} key={index} sx={contactGridStyle}>
                            <Typography variant="h5">{element.supportType}</Typography>
                            <Typography variant="h4">
                                {formatPhoneNumber(element.phoneNumber)}
                            </Typography>
                            <EmailLink email={element.email} />
                        </Grid>
                    ))}
                </Grid>
            </Card>
        );
    }
};

export const supportCardStyle: SxProps<Theme> = () => ({
    display: 'block',
    borderRadius: '0.625rem',
    padding: '0.625rem',
    boxShadow: '0 0.125rem 0.375rem 0 #0000001A',
    margin: '0.875rem auto'
});

const mainGridStyle: SxProps<Theme> = () => ({
    display: 'flex',
    flexWrap: 'wrap'
});

const contactGridStyle: SxProps<Theme> = () => ({
    display: 'block',
    paddingRight: '2.25rem',
    marginTop: '0.5rem'
});

export default SupportCard;
